<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Cliente</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('pessoa.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('pessoa.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('pessoa.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'pessoa'"> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    :load-on-start="false"
                    no-data-template="Para retornar algum dado, o usuário deve aplicar os filtros e clicar em filtrar"
                    ref="vuetable"
                    api-url="/api/pessoa"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="pessoa_id"
                    pagination-path=""
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="pessoa-detalhes"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>

                    <template slot="identificacao" slot-scope="props">
                      <span v-if="props.rowData.pessoa_juridica !== null">{{
                        ajustaMascara(
                          onFormataCnpj(
                            props.rowData.pessoa_juridica.cnpj_base,
                            props.rowData.pessoa_juridica.cnpj_filial,
                            props.rowData.pessoa_juridica.cnpj_digito
                          ),
                          2
                        )
                      }}</span>
                      <span v-if="props.rowData.pessoa_exterior !== null">{{
                        props.rowData.pessoa_exterior.cuit
                      }}</span>
                      <span v-if="props.rowData.pessoa_fisica !== null">{{
                        ajustaMascara(props.rowData.pessoa_fisica.cpf, 1)
                      }}</span>
                    </template>

                    <template slot="identificacaonome" slot-scope="props">
                      <span v-if="props.rowData.pessoa_juridica !== null">{{
                        props.rowData.pessoa_juridica.razao_social
                      }}</span>
                      <span v-if="props.rowData.pessoa_exterior !== null">{{
                        props.rowData.pessoa_exterior.nome
                      }}</span>
                      <span v-if="props.rowData.pessoa_fisica !== null">{{
                        props.rowData.pessoa_fisica.nome
                      }}</span>
                    </template>
                    <template slot="tp_pessoa" slot-scope="props">
                      <span
                        class="badge badge-secondary"
                        v-if="props.rowData.liv_tipo_pessoa.valor == 1"
                        >{{ props.rowData.liv_tipo_pessoa.descr }}</span
                      >
                      <span
                        class="badge badge-primary"
                        v-if="props.rowData.liv_tipo_pessoa.valor == 2"
                        >{{ props.rowData.liv_tipo_pessoa.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.liv_tipo_pessoa.valor == 3"
                        >{{ props.rowData.liv_tipo_pessoa.descr }}</span
                      >
                    </template>
                    <template slot="fornecedor" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.liv_fornecedor.valor == 1"
                        >{{ props.rowData.liv_fornecedor.descr }} -
                        {{ props.rowData.liv_tp_fornecedor.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.liv_fornecedor.valor == 2"
                        >{{ props.rowData.liv_fornecedor.descr }}</span
                      >
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="status_erp" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status_erp.valor == 1"
                        >{{ props.rowData.status_erp.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status_erp.valor == 2"
                        >{{ props.rowData.status_erp.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status_erp.valor == 3"
                        >{{ props.rowData.status_erp.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          v-if="getPermissionFw('pessoa.update')"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <span v-if="getPermissionFw('pessoa.status')">
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                          <a
                            @click="onEventoGerRisco(props.rowData, 1)"
                            v-b-tooltip
                            title="Cadastrar gerenciamento risco"
                            v-if="(props.rowData.pessoa_fisica != null && props.rowData.pessoa_fisica.param_ocupacao != null
                              && props.rowData.pessoa_fisica.param_ocupacao.cd_erp == 2)"
                            ><i class="fa fa-external-link"></i
                          ></a>
                          <a
                            @click="sendDoc(props.rowData.pessoa_ajudante.pesaju_id)"
                            v-b-tooltip
                            title="Enviar foto gerenciamento risco"
                            v-if="(props.rowData.pessoa_fisica != null && props.rowData.pessoa_fisica.param_ocupacao != null
                              && props.rowData.pessoa_fisica.param_ocupacao.cd_erp == 2)"
                          ><i class="fa fa-picture-o"></i
                          ></a>
                          <a
                            @click="onEventoGerRisco(props.rowData, 2)"
                            v-b-tooltip
                            title="Consultar gerenciamento risco"
                            v-if="(props.rowData.pessoa_fisica != null && props.rowData.pessoa_fisica.param_ocupacao != null
                              && props.rowData.pessoa_fisica.param_ocupacao.cd_erp == 2)"
                            ><i class="fa fa-compass"></i
                          ></a>
                          <a
                            @click="onEventoGerRisco(props.rowData, 3)"
                            v-b-tooltip
                            title="Pesquisa gerenciamento risco"
                            v-if="(props.rowData.pessoa_fisica != null && props.rowData.pessoa_fisica.param_ocupacao != null
                              && props.rowData.pessoa_fisica.param_ocupacao.cd_erp == 2)"
                            ><i class="fa fa-search"></i
                          ></a>
                          <a
                            @click="onEventoGerRisco(props.rowData, 4)"
                            v-b-tooltip
                            title="Pesquisa expressa gerenciamento risco"
                            v-if="(props.rowData.pessoa_fisica != null && props.rowData.pessoa_fisica.param_ocupacao != null
                              && props.rowData.pessoa_fisica.param_ocupacao.cd_erp == 2)"
                            ><i class="fa fa-bolt"></i
                          ></a>
                          <a
                            v-if="props.rowData.liv_fornecedor.valor == 1"
                            @click="onIntegration(props.rowData.pessoa_id)"
                            v-b-tooltip
                            title="Integrar Gestão de pagamento"
                            ><i class="fa fa-credit-card"></i
                          ></a>
                        </span>
                        <a
                          v-if="
                            getPermissionFw('pessoa.reenviarfornecedor') &&
                            props.rowData.liv_fornecedor.valor == 1
                          "
                          @click="onReenvioErp(props.rowData.pessoa_id)"
                          v-b-tooltip
                          title="Reenviar ERP"
                          ><i class="fa fa-reply"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SendDocForm ref="senddocform" :rota="'pessoa/gerenciamentorisco'" />
      <PessoaForm
        ref="pessoaform"
        :metodo="onFilterReset"
        :tabela="'pessoa'"
        :rota="'pessoa'"
      >
      </PessoaForm>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import PessoaFilterBar from "./PessoaFilterBar";
import PessoaForm from "./PessoaForm";
import PessoaDetalhes from "./PessoaDetalhes";
import SendDocForm from "./SendDocForm.vue";

import { formatCNPJFromParts } from "../utils";

Vue.component("pessoa-detalhes", PessoaDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PessoaForm,
    SendDocForm,
    "vuetable-filterbar": PessoaFilterBar,
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      optionsLivStatus: [],
      optionsTpMontagemCargaPortal: [],
      optionsEnvioEmailParceiro: [],
      optionsEnvioEmailOcorrencia: [],
      optionsLivTipoPessoa: [],
      optionsExigeAverbacao: [],
      optionsValidaOpentech: [],
      optionsTpVinculoAjudante: [],
      optionsLivIndie: [],
      optionsLivFornecedor: [],
      optionsLivFornecedorFilter: [],
      optionsLivStatusReferencia: [],
      optionsRgUf: [],
      optionsLivVipNacional: [],
      optionsLivVipInternacional: [],
      optionsLivContatoEmailDefault: [],
      optionsTpSituacao: [],
      optionsLivContatoEmailStatus: [],
      optionsLivStatusFinanceiro: [],
      optionsLivStatusMotorista: [],
      optionsTpVinculoMotorista: [],
      optionsCategoriaCnh: [],
      optionsLivStatusTel: [],
      optionsParamRelacionamento: [],
      optionsParamNacionalidade: [],
      optionsIsFornecedor: [],
      optionsParTpEma: [],
      optionsMunicipio: [],
      optionsTpPessoa: [],
      optionsCnae: [],
      optionsTpProprietario: [],
      optionsTpFornecedor: [],
      optionsRetira: [],
      optionsStatusErp: [],
      optionsParEnd: [],
      optionsUf: [],
      optionsTpSituacaoResidencia: [],
      optionsDocPagamento: [],
      optionsFormaPag: [],
      optionsLivIsPadrao: [],
      optionsLivTipoTel: [],
      optionsGerarPreFatura: [],
      optionsStatusVendaServico: [],
      optionsControlaDtEntrega: [],
      optionsLivStatusFilter: [],
      optionsOperadora: [],
      optionsParamBanco: [],
      optionsSexo: [],
      optionsLivSimplesNacional: [],
      optionsLivCreditoPresumido: [],
      optionsLivPedagioBaseCalculoIcms: [],
      optionsParamCategoriaCfop: [],
      optionsParamOcupacao: [],
      optionsParamEstadoCivil: [],
      optionsBEtiquetaLayout: [],
      optionsTpConta: [],
      optionsEdoccob: [],
      optionsPrazoEdoccob: [],
      optionsPermitirAdiantamento: [],
      loadingData: false,
      showModal: false,
      form: new Form({ cd: "", descr: "", pessoa_id: "", status: [] }),
      helpForm: new Form({ statusRecord: [], pessoa_id: "", tipo_evento: ""}),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd",
        },
        {
          name: "__slot:tp_pessoa",
          title: "Tipo",
          sortField: "tp_pessoa",
        },
        {
          name: "__slot:fornecedor",
          title: "Fornecedor",
          sortField: "tp_fornecedor",
        },
        {
          name: "tp_montagem_carga_portal.descr",
          title: "Tipo da Montagem de Carga",
          sortField: "tp_montagem_carga_portal",
        },
        {
          name: "__slot:identificacao",
          title: "CNPJ/CPF",
          sortField: "cnpj",
        },
        {
          name: "__slot:identificacaonome",
          title: "Razão Social/Nome",
          sortField: "cnpj",
        },
        {
          name: "pessoa_juridica.inscricao_estadual",
          title: "Inscrição Estadual",
          sortField: "inscricao_estadual",
        },
        {
          name: "__slot:status_erp",
          title: "Status ERP",
          sortField: "status_erp",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.getLivGeral();
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
  },
  methods: {
    getLivGeral() {
      this.helpForm
        .get("/api/pessoa/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.indie.forEach((obj) => {
            this.optionsLivIndie.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_pessoa.forEach((obj) => {
            this.optionsTpPessoa.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.municipio.forEach((obj) => {
            this.optionsMunicipio.push({
              label: obj.nome + " - " + obj.uf.cd,
              value: obj.municipio_id,
              ibge: obj.cd_ibge,
            });
          });

          response.status.forEach((obj) => {
            this.optionsLivStatus.push({
              text: obj.descr,
              value: obj.valor,
            });
            this.optionsLivStatusFilter.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.fornecedor.forEach((obj) => {
            this.optionsLivFornecedor.push({
              text: obj.descr,
              value: obj.valor,
            });
            this.optionsLivFornecedorFilter.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.vip_nacional.forEach((obj) => {
            this.optionsLivVipNacional.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.vip_internacional.forEach((obj) => {
            this.optionsLivVipInternacional.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.sexo.forEach((obj) => {
            this.optionsSexo.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.cnae.forEach((obj) => {
            this.optionsCnae.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.cnae_id,
            });
          });

          response.partpema.forEach((obj) => {
            this.optionsParTpEma.push({
              label: obj.descr,
              value: obj.partpema_id,
            });
          });

          response.email_status.forEach((obj) => {
            this.optionsLivContatoEmailStatus.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.email_default.forEach((obj) => {
            this.optionsLivContatoEmailDefault.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.pesend_is_padrao.forEach((obj) => {
            this.optionsLivIsPadrao.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.parend.forEach((obj) => {
            this.optionsParEnd.push({
              label: obj.descr,
              value: obj.parend_id,
            });
          });

          response.operadora.forEach((obj) => {
            this.optionsOperadora.push({
              label: obj.descr,
              value: obj.partelope_id,
            });
          });

          response.tipo_tel.forEach((obj) => {
            this.optionsLivTipoTel.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.gerar_pre_fatura.forEach((obj) => {
            this.optionsGerarPreFatura.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.status_venda_servico.forEach((obj) => {
            this.optionsStatusVendaServico.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.controla_dt_entrega.forEach((obj) => {
            this.optionsControlaDtEntrega.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.simples_nacional.forEach((obj) => {
            this.optionsLivSimplesNacional.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.credito_presumido.forEach((obj) => {
            this.optionsLivCreditoPresumido.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.pedagio_base_calculo_icms.forEach((obj) => {
            this.optionsLivPedagioBaseCalculoIcms.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.forma_pag.forEach((obj) => {
            this.optionsFormaPag.push({
              label: obj.descr,
              value: obj.parforpag_id,
            });
          });
          response.banco.forEach((obj) => {
            this.optionsParamBanco.push({
              label: obj.descr,
              value: obj.parban_id,
            });
          });

          response.financeiro_status.forEach((obj) => {
            this.optionsLivStatusFinanceiro.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.status_tel.forEach((obj) => {
            this.optionsLivStatusTel.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.status_motorista.forEach((obj) => {
            this.optionsLivStatusMotorista.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_vinculo_motorista.forEach((obj) => {
            this.optionsTpVinculoMotorista.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.categoria_cnh.forEach((obj) => {
            this.optionsCategoriaCnh.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_fornecedor.forEach((obj) => {
            this.optionsTpFornecedor.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_proprietario.forEach((obj) => {
            this.optionsTpProprietario.push({
              label: obj.descr,
              value: obj.partipppt_id,
            });
          });
          response.exige_averbacao.forEach((obj) => {
            this.optionsExigeAverbacao.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.valida_opentech.forEach((obj) => {
            this.optionsValidaOpentech.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_vinculo_ajudante.forEach((obj) => {
            this.optionsTpVinculoAjudante.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_situacao_residencia.forEach((obj) => {
            this.optionsTpSituacaoResidencia.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.param_relacionamento.forEach((obj) => {
            this.optionsParamRelacionamento.push({
              label: obj.descr,
              value: obj.parrel_id,
            });
          });
          response.param_nacionalidade.forEach((obj) => {
            this.optionsParamNacionalidade.push({
              label: obj.descr,
              value: obj.parnac_id,
            });
          });
          response.param_categoria_cfop.forEach((obj) => {
            this.optionsParamCategoriaCfop.push({
              label: obj.descr,
              value: obj.parcatcfo_id,
            });
          });
          response.uf.forEach((obj) => {
            this.optionsUf.push({
              label: obj.cd,
              value: obj.uf_id,
            });
          });
          response.status_referencia.forEach((obj) => {
            this.optionsLivStatusReferencia.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.uf.forEach((obj) => {
            this.optionsRgUf.push({
              label: obj.cd,
              value: obj.uf_id,
            });
          });
          response.tp_montagem_carga_portal.forEach((obj) => {
            this.optionsTpMontagemCargaPortal.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.envio_email_parceiro.forEach((obj) => {
            this.optionsEnvioEmailParceiro.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.envio_email_ocorrencia.forEach((obj) => {
            this.optionsEnvioEmailOcorrencia.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.param_ocupacao.forEach((obj) => {
            this.optionsParamOcupacao.push({
              label: obj.descr,
              value: obj.parocupa_id,
            });
          });
          response.param_estado_civil.forEach((obj) => {
            this.optionsParamEstadoCivil.push({
              label: obj.descr,
              value: obj.parestciv_id,
            });
          });
          response.tp_conta.forEach((obj) => {
            this.optionsTpConta.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.edoccob.forEach((obj) => {
            this.optionsEdoccob.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.retira.forEach((obj) => {
            this.optionsRetira.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.prazo_edoccob.forEach((obj) => {
            this.optionsPrazoEdoccob.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.permitir_adiantamento.forEach((obj) => {
            this.optionsPermitirAdiantamento.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.status_erp.forEach((obj) => {
            this.optionsStatusErp.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.b_etiqueta_layout.forEach((obj) => {
            this.optionsBEtiquetaLayout.push({
              text: obj.descr,
              value: obj.betilay_id,
            });
          });
          response.tp_situacao.forEach((obj) => {
            this.optionsTpSituacao.push({
              label: obj.descr, 
              value: obj.valor,
            });
          });
          response.doc_pagamento.forEach((obj) => {
            this.optionsDocPagamento.push({
              label: obj.descr, 
              text: obj.descr, 
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
     onEventoGerRisco(data, tipo_evento) {
      this.helpForm.pessoa_id = data.pessoa_id;
      this.helpForm.tipo_evento = tipo_evento;
      this.helpForm
        .post("/api/pessoa/gerenciamentorisco")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    sendDoc(data) {
      this.$refs.senddocform.onCreate(data);
    },
    onIntegration(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.pessoa_id = id;
      this.helpForm
        .post("/api/pessoa/gestaopagamento")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onReenvioErp(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.pessoa_id = id;
      this.helpForm
        .patch("/api/pessoa/reenviarfornecedor")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.pessoa_id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        cd: data_filter.cd,
        cnpj: data_filter.cnpj,
        nome: data_filter.nome,
        dt_expiracao_ini: data_filter.dt_expiracao_ini,
        dt_expiracao_fim: data_filter.dt_expiracao_fim,
        tp_situacao: data_filter.tp_situacao.value,
        inscricao_estadual: data_filter.inscricao_estadual,
        status: data_filter.status.value,
        fornecedor: data_filter.fornecedor.value,
        status_erp: data_filter.status_erp.value,
        municipio: data_filter.municipio.value,
        tipo_pessoa: data_filter.tp_pessoa.value,
      };
      if(data_filter.tp_situacao.value == 0){
        this.moreParams.tp_situacao = 99;
      }
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.$refs.pessoaform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.pessoa_id;
      this.$refs.pessoaform.onEdit(data, index, this.id);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({id: data.pessoa_id, status: action});
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({id: obj, status: action});
        });
      }
      this.$refs.pessoaform.onActivateDesactivate(this.helpForm);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },

    ajustaMascara(data, tipo) {
      if (tipo === 1) {
        //cpf
        return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      if (tipo === 2) {
        //cnpj
        return data.replace(
          /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
    },

    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>